import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { LineChart, BarChart , CandlestickChart } from 'echarts/charts';
import {
    GridComponent,
    TooltipComponent,
    TitleComponent,
    TimelineComponent,
    MarkPointComponent,
    MarkLineComponent,
    MarkAreaComponent,
    LegendComponent,
    DataZoomComponent,
    DataZoomInsideComponent,
    DataZoomSliderComponent,
    VisualMapComponent,
    VisualMapContinuousComponent,
    VisualMapPiecewiseComponent,
} from 'echarts/components';
import {
    CanvasRenderer,
} from 'echarts/renderers';
import Typography from '@mui/material/Typography';

echarts.use(
    [VisualMapComponent, VisualMapContinuousComponent, VisualMapPiecewiseComponent, TitleComponent, TooltipComponent, GridComponent, LineChart, CandlestickChart, CanvasRenderer, DataZoomComponent,
        DataZoomInsideComponent, DataZoomSliderComponent, MarkPointComponent, MarkLineComponent, TimelineComponent,
        LegendComponent, MarkAreaComponent, BarChart ]
);


const useStyles = makeStyles(theme => ({
    table: {
        // minWidth: 650,
    },
    root1: {
        flexGrow: 1,
    },
    menuButton: {
        // marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
    },
    grid: {
        // width: `calc(100% + ${6 + (theme.spacing(1))}px)`
    }
}));



export default function KChart(props) {
    const classes = useStyles();
    const theme = useTheme();

    const [option, setOption] = React.useState(null);
    const [result, setResult] = React.useState(null);

    function genoption1() {
        let k = {
            animation:false,
            grid: [{
                top: 10,
                left: 0,
                right: 0,
                // height: 100,
                bottom: 0,
                containLabel:true
            }],
            xAxis: [{
                type: 'category',
                boundaryGap: false,
                data: props.row.bprice.map(row => row.x),
            }],
            yAxis: [{
                scale: true,
                type: 'value',
                position: 'left',
                show: true,            
            },{
                scale: true,
                type: 'value',
                position: 'right',
                show: true,            
            }],
            series: [
                {
                    name: '價格1',
                    type: 'line',
                    data: props.row.bprice.map(row => row.y),
                    smooth: true,
                    showSymbol: false,
                },
                {
                    name: '價格2',
                    type: 'line',
                    data: props.row.tprice.map(row => row.y),
                    smooth: true,
                    showSymbol: false,
                    xAxisIndex: 0,
                    yAxisIndex: 1,
                }
            ]
        };
        return k;
    }

    useEffect(() => {
        // fetchData()
        if(props.row != null) setOption(genoption1)
    }, []);

    const clickDetail = () => {
        if(props.setOpen != null) props.setOpen(true)
    }

    return (
        <div style={{padding:1}}  onClick={e => clickDetail()}>
            <Typography fontWeight={"bold"} fontSize={14}>股價走勢</Typography>
            {option != null ?
                <ReactEChartsCore
                    theme={theme.palette.mode}
                    echarts={echarts}
                    option={option}
                    notMerge={true}
                    lazyUpdate={false}
                    style={{ height: 150 }}
                // onEvents={onEvents}
                />
                : null}
        </div>
    );
}

